<p><strong [innerHtml]="field.templateOptions.label"></strong></p>

<div class="phone-inputs">

  <span class="required" *ngIf="field.templateOptions.required">*</span>

  <bee-select [items]="countries" [(selectedItem)]="selectedCountry"></bee-select>  

  <input type="input" [formControl]="formControl" [formlyAttributes]="field">
</div>